import React, { FC, useEffect, useState } from "react";
import AEAGrid from "../../../ui/aea-grid/aea-grid";
import { IMainBudget } from "@interfaces/screens/main-budget.interface";
import { MainBudgetPresenter } from "@presenters/screens/main-budget.presenter";

const FullDetailDataBudget: FC<any> = () => {
  const [dataColumns, setDataColumns] = useState(null);
  const [dataSource, setDataSource] = useState([]);

  const view: IMainBudget = {
    state: {
      dataSource,
      dataColumns,
      setDataColumns,
      setDataSource,
    },
  };
  const presenter = new MainBudgetPresenter(view);

  useEffect(() => {
    const ac = new AbortController();
    presenter.initializeDetail();
    return () => ac.abort();
  }, []);

  return (
    <div>
      <AEAGrid {...presenter.dsDetailProps}></AEAGrid>
    </div>
  );
};
export default FullDetailDataBudget;
